export const ANALYSE_STEPS = [
  {
    name: 'allocation',
    substeps: 5,
    helps: [
      null,
      [ 'analyse.allocation.helps.profile' ],
      [
        'analyse.allocation.helps.strategy[0]',
        'analyse.allocation.helps.strategy[1]',
        'analyse.allocation.helps.strategy[2]'
      ]
    ]
  },
  {
    name: 'performances',
    substeps: 5,
    hideSteps: [4],
    helps: [
      null,
      ['analyse.performances.helps.passed'],
      ['analyse.performances.helps.funds']
    ]
  },
  {
    name: 'risk',
    substeps: 5,
    helps: [
      null,
      ['analyse.risk.helps.allocation']
    ]
  },
  {
    name: 'fees',
    substeps: 5,
    helps: [
      null,
      ['analyse.fees.helps.contract'],
      ['analyse.fees.helps.funds'],
      ['analyse.fees.helps.total']
    ]
  },
  {
    name: 'advices',
    substeps: 3
    // substeps: 4
  }
]
